import { Provider, APP_INITIALIZER, EnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors, HttpInterceptorFn } from '@angular/common/http';

/**
 * Factory function que cria os providers de auth de forma centralizada
 * Evita import direto de data-access/auth no angular-config
 *
 * @param authService - O serviço de auth injetado pela app
 * @param authInterceptor - O interceptor de auth injetado pela app
 * @param additionalInterceptors - Interceptors adicionais (ex: httpConfigInterceptor)
 */
export function createAuthProviders(
  authService: any, // any para evitar import circular
  authInterceptor: any,
  ...additionalInterceptors: HttpInterceptorFn[]
): (Provider | EnvironmentProviders)[] {
  // Factory function para inicializar auth
  function initializeAuth(authSvc: any) {
    return (): Promise<void> => authSvc.checkSession();
  }

  return [
    // HTTP Client com interceptors globais
    // ORDEM: httpConfigInterceptor → authInterceptor
    provideHttpClient(withInterceptors([...additionalInterceptors, authInterceptor])),

    // AUTH INITIALIZER - Configurado UMA VEZ
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [authService],
      multi: true,
    },
  ];
}
